// extracted by mini-css-extract-plugin
export default {"inputPhoneNumberWithIntegration":"VariableLeadField_inputPhoneNumberWithIntegration__zr6tZ","borderRadius":"VariableLeadField_borderRadius__AhjAi"};